import React, { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { auth, db } from '../firebase';
import styles from './Facturacion.module.css';

export default function Facturacion() {
  const [facturas, setFacturas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      setFacturas([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, 'facturas'),
      where('uid', '==', user.uid),
      orderBy('fecha', 'desc')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const facturasData = [];
      snapshot.forEach(doc => {
        facturasData.push({ id: doc.id, ...doc.data() });
      });
      setFacturas(facturasData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <p className={styles.cargando}>Cargando facturas...</p>;

  if (facturas.length === 0)
    return <p className={styles.noFacturas}>No tienes facturas disponibles.</p>;

  return (
    <div className={styles.container}>
      <h2>Historial de Facturación</h2>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Nº Factura</th>
            <th>Fecha</th>
            <th>Importe</th>
            <th>Estado</th>
            <th>Detalles</th>
          </tr>
        </thead>
        <tbody>
          {facturas.map(({ id, numero, fecha, importe, estado, detalles }) => (
            <tr key={id} className={styles.fila}>
              <td>{numero || id}</td>
              <td>{fecha?.toDate ? fecha.toDate().toLocaleDateString() : '—'}</td>
              <td>{importe ? `$${importe.toFixed(2)}` : '—'}</td>
              <td className={estado === 'pagado' ? styles.pagado : styles.pending}>
                {estado || 'pendiente'}
              </td>
              <td>{detalles || 'Sin detalles'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
